import React from "react";

// import Navbar from "./Navbar/Navbar";
import Layout from "../../hoc/Layout/Layout";
import Hero from "./Hero/Hero";
import About from "./About/About";
import Services from "./Services/Services";
import Galery from "./Galery/Galery";
import Contact from "../../containers/Contact/Contact";
import Footer from "./Footer/Footer";
import VideoYoutube from "./VideoYoutube/VideoYoutube";

const cloackroom = () => {
  return (
    <div>
      <Layout>
        <Hero />
        <About />
        <Services />
        <Galery />
        <VideoYoutube />
        <Contact />
        <Footer />
      </Layout>
    </div>
  );
};

export default cloackroom;



// WEBPACK FOOTER //
// ./src/components/Cloackroom/Cloakroom.js